import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
} from 'reactstrap';

const FreightTimeline = ({
    items = [],
    t,
}) => {
    return (
        <Card>
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{t('Freight Timeline')}</h5>
                    <ButtonLink label={t('View all')} />
                </div>

                <div className="freight-timeline">
                    {items.map((item) => (
                        <div className={`freight-timeline-item${item.completed ? ' completed' : ''}`} key={item.id}>
                            <span className="timeline-marker">
                                {item.completed && <i className="ri-check-line" />}
                            </span>

                            <div className="timeline-content">
                                <span>{t(item.title)}</span>
                                <small className="text-muted">{item.date}</small>
                                {item.detail && <small className="text-muted">{t(item.detail)}</small>}
                            </div>
                        </div>
                    ))}
                </div>
            </CardBody>
        </Card>
    );
};

const ButtonLink = ({
    label,
}) => (
    <button className="btn btn-link btn-sm p-0" type="button">
        {label}
    </button>
);

export default withNamespaces()(
    FreightTimeline
);
